import React, {KeyboardEventHandler} from 'react';
import {Field} from '../types/Field';
import {OnChangeFn} from '../widgets/CheckboxWidget';
import {NumberWidget} from '../widgets/NumberWidget';
import {useOnChange} from './hooks/useOnChange';
import {useTextProps} from './hooks/useTextProps';
import {dummyResourceDetails, ResourceDetails} from '../types/ResourceDetails';
import {Schema} from '../types/Schema';
import {Actions} from '../types/Action';
import {widgetProps} from '../widgets/common';
import {WidgetStyles} from '../types/WidgetStyles';
import {useOnPressAction} from './hooks/useOnPressAction';

type Props = {
  value: any;
  onChange: OnChangeFn;
  field: Field;
  readOnly?: boolean;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  item?: ResourceDetails;
  schema: Schema;
  actions: Actions;
};

export function NumberField(props: Props): JSX.Element | null {
  const onChange = useOnChange(props.onChange, props.field.id);
  const textProps = useTextProps(props.field, false);
  const min = props.field.minValue;
  const max = props.field.maxValue;
  const value = toString(props.value);
  const onPress = useOnPressAction(
    props.field,
    props.schema,
    props.item ?? dummyResourceDetails(),
    props.actions,
  );

  const styles = widgetProps<WidgetStyles | undefined>(
    props.field,
    'styles',
    undefined,
  );

  return (
    <NumberWidget
      {...props}
      {...textProps}
      value={value}
      onChange={onChange}
      min={min}
      max={max}
      onPress={onPress}
      styles={styles}
    />
  );
}

function toString(value: any): string {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value);
}
